import { Map } from 'immutable';
import { actionTypes as overviewTabActionTypes } from '../../actions/LotPage/overviewTabActions';
import {actionTypes as lotPageActionTypes} from '../../actions/LotPage/lotPageActions';

let defaultState = {
  lotDetails: {},
  loading: false,
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    case overviewTabActionTypes.LOT_PAGE_OVERVIEW_TAB_FETCHDATA_STARTED:
      return state.set('loading', true);

    case overviewTabActionTypes.LOT_PAGE_OVERVIEW_TAB_FETCHDATA_FINISHED:
      state = state.set('lotDetails', action.payload).set('loading', false);
      return state;

    case lotPageActionTypes.LOT_PAGE_SET_BUSY:  //Note: workaround - show Loading overlay in OverviewTab
      return state.set('loading', action.payload);
    default:
      return state;
  }
}
